module.exports = __webpack_public_path__ + "static/media/01-primary-color.d8d1eead.png";